import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

// Kiểm tra trong trường hợp kích thước từ tablet to trở lên
const useIsDesktop = () => {
  const theme = useTheme()

  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))
  return isDesktop
}

export default useIsDesktop
